/// <amd-module name="Wit/WorkItemForm/History/Diffs/HtmlFieldDiff" />
import * as React from "react";
import { WorkItemFieldUpdate } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { FieldName, FieldValue } from "../../Common/Components";

export interface IHtmlFieldDiffProps {
    refName: string;
    fieldUpdate: WorkItemFieldUpdate;
}

export function HtmlFieldDiff({ refName, fieldUpdate }: IHtmlFieldDiffProps) {
    const addedValue = fieldUpdate.newValue ? (
        <div className="added html-field-value padding-vertical-4 padding-horizontal-8 margin-bottom-8">
            <ins>
                <FieldValue refName={refName} fieldValue={fieldUpdate.newValue} />
            </ins>
        </div>
    ) : null;
    const removedValue = fieldUpdate.oldValue ? (
        <div className="removed html-field-value padding-vertical-4 padding-horizontal-8 margin-bottom-8">
            <del>
                <FieldValue refName={refName} fieldValue={fieldUpdate.oldValue} />
            </del>
        </div>
    ) : null;

    return (
        <div className="html-field-diff">
            <div className="font-size-ml font-weight-semibold margin-bottom-8">
                <FieldName refName={refName} />
            </div>
            {addedValue}
            {removedValue}
        </div>
    );
}
